"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Small = function (_a) {
    var id = _a.id, fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["id", "fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1000 1000" }, rest),
        react_1.default.createElement("path", { d: "M295.42 6c-53.2 2.51-89.53 11-121.29 23.48-32.87 12.81-60.73 30-88.45 57.82S40.89 143 28.17 175.92c-12.31 31.83-20.65 68.19-23 121.42S2.3 367.68 2.56 503.46 3.42 656.26 6 709.6c2.54 53.19 11 89.51 23.48 121.28 12.83 32.87 30 60.72 57.83 88.45S143 964.09 176 976.83c31.8 12.29 68.17 20.67 121.39 23s70.35 2.87 206.09 2.61 152.83-.86 206.16-3.39S799.1 988 830.88 975.58c32.87-12.86 60.74-30 88.45-57.84s44.77-55.74 57.48-88.68c12.32-31.8 20.69-68.17 23-121.35 2.33-53.37 2.88-70.41 2.62-206.17s-.87-152.78-3.4-206.1-11-89.53-23.47-121.32c-12.85-32.87-30-60.7-57.82-88.45S862 40.87 829.07 28.19c-31.82-12.31-68.17-20.7-121.39-23S637.33 2.3 501.54 2.56 348.75 3.4 295.42 6m5.84 903.88c-48.75-2.12-75.22-10.22-92.86-17-23.36-9-40-19.88-57.58-37.29s-28.38-34.11-37.5-57.42c-6.85-17.64-15.1-44.08-17.38-92.83-2.48-52.69-3-68.51-3.29-202s.22-149.29 2.53-202c2.08-48.71 10.23-75.21 17-92.84 9-23.39 19.84-40 37.29-57.57s34.1-28.39 57.43-37.51c17.62-6.88 44.06-15.06 92.79-17.38 52.73-2.5 68.53-3 202-3.29s149.31.21 202.06 2.53c48.71 2.12 75.22 10.19 92.83 17 23.37 9 40 19.81 57.57 37.29s28.4 34.07 37.52 57.45c6.89 17.57 15.07 44 17.37 92.76 2.51 52.73 3.08 68.54 3.32 202s-.23 149.31-2.54 202c-2.13 48.75-10.21 75.23-17 92.89-9 23.35-19.85 40-37.31 57.56s-34.09 28.38-57.43 37.5c-17.6 6.87-44.07 15.07-92.76 17.39-52.73 2.48-68.53 3-202.05 3.29s-149.27-.25-202-2.53m407.6-674.61a60 60 0 1 0 59.88-60.1 60 60 0 0 0-59.88 60.1M245.77 503c.28 141.8 115.44 256.49 257.21 256.22S759.52 643.8 759.25 502 643.79 245.48 502 245.76 245.5 361.22 245.77 503m90.06-.18a166.67 166.67 0 1 1 167 166.34 166.65 166.65 0 0 1-167-166.34", transform: "translate(-2.5 -2.5)", style: {
                fill: '#fff',
            } })));
};
var Instagram = function (props) {
    var id = props.id, height = props.height, width = props.width, fill = props.fill, title = props.title, background = props.background, _a = props.max, max = _a === void 0 ? 5 : _a, children = props.children, rest = __rest(props, ["id", "height", "width", "fill", "title", "background", "max", "children"]);
    var fillId = 'instagramGradient' + (id || '');
    var fillReference = "url(#" + fillId + ")";
    if (fill) {
        fillReference = fill;
    }
    var retract = 0;
    var maxRadius = max;
    var radius = maxRadius;
    var defaultWidth = 100;
    var defaultHeight = 100;
    if (typeof width === 'number' && typeof height === 'number') {
        defaultWidth = width;
        defaultHeight = height;
        radius = width / 2;
    }
    else if (typeof width === 'number') {
        radius = width / 2;
        defaultWidth = width;
        defaultHeight = width;
    }
    else if (typeof height === 'number') {
        radius = height / 2;
        defaultWidth = height;
        defaultHeight = height;
    }
    var showChildren = children && radius > 57;
    if (showChildren) {
        if (radius - maxRadius < 25) {
            retract = radius - maxRadius;
        }
        maxRadius = 22;
    }
    else {
        maxRadius = radius / 2;
    }
    return (react_1.default.createElement("svg", __assign({ width: defaultWidth, height: defaultHeight, viewBox: "0 0 " + defaultWidth + " " + defaultHeight, fill: fillReference, version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { x1: "0%", x2: "100%", y1: "97.0782153%", y2: "0%", id: fillId },
                react_1.default.createElement("stop", { offset: "0%", stopColor: "#F50102" }),
                react_1.default.createElement("stop", { offset: "100%", stopColor: "#B902B3" }))),
        background ? (react_1.default.createElement("rect", { width: defaultWidth, height: defaultHeight })) : (react_1.default.createElement("circle", { cx: radius, cy: radius, r: radius })),
        react_1.default.createElement("g", { transform: "translate(" + (defaultWidth / 2 - maxRadius) + "," + (defaultHeight / 2 - maxRadius - retract) + ")" },
            react_1.default.createElement(Small, __assign({ id: id + '-inner', width: maxRadius * 2, height: maxRadius * 2, fill: "none" }, rest))),
        showChildren && (react_1.default.createElement("g", { transform: "translate(" + radius + "," + (radius + maxRadius + 28 - retract) + ")" },
            react_1.default.createElement("text", { textAnchor: "middle", fontSize: 14, fill: "#fff" }, children)))));
};
exports.default = Instagram;
